import { defaultPathComponent } from '@common/constants/shared';
import {
  setDefaultValueInput,
  setValueInput,
} from '@common/redux/slice/formInputs';
import {
  convertDate,
  convertImage,
  getValueBindingComponent,
  memoriesConditional,
} from '@common/utils/component';
import { get, isEmpty, isEqual } from 'lodash';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { IObj } from '@common/types';

const connectorInput = (InputComponent: any) =>
  React.memo((props: any) => {
    const { dependencies = {} } = props;
    const { valueInputs, defaultValues = {} } = dependencies;
    const dispatch = useDispatch();

    const changeInput = useCallback(
      (value: any) => {
        const valueInput = {
          [props.id]: value,
        };
        dispatch(setValueInput(valueInput));
      },
      [props.id]
    );

    useEffect(() => {
      if (props?.isFormItem) return;

      const getDefaultValue = (props: IObj) => {
        const valueBinding = getValueBindingComponent(
          props,
          defaultPathComponent[props.type]
        );
        switch (props.type) {
          case 'date-picker':
            return convertDate(valueBinding, props);
          case 'image-upload':
            const image = convertImage(props);
            if (!isEmpty(image)) {
              return typeof image === 'string' ? { url: image } : image;
            } else {
              return valueBinding && typeof valueBinding === 'string'
                ? JSON.parse(valueBinding)
                : valueBinding;
            }
          // return !isEmpty(image) && typeof image === 'string'
          //   ? { url: image }
          //   : image;
          default:
            return valueBinding;
        }
      };

      const defaultValue = getDefaultValue(props);
      // compare and reset default value
      if (defaultValue && !isEqual(defaultValue, defaultValues[props.id])) {
        dispatch(setDefaultValueInput({ [props.id]: defaultValue }));
      }
    }, [props.id, props.data, defaultValues]);

    const valueInput = useMemo(
      () => get(valueInputs, props.id),
      [valueInputs, props.id]
    );

    const placeholder = get(
      props,
      'defaultValue.binding.options',
      props?.placeholder
    );

    const params = { changeInput, valueInput, placeholder };

    return <InputComponent {...props} {...params} />;
  }, memoriesConditional(['dependencies', 'data', 'id', 'dataBinding']));

export default connectorInput;
